import React, { useEffect, useState } from "react";
import withRouter from "components/Common/withRouter";
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap"
import classnames from "classnames"
import { Link, useLocation, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb";
import toast from "react-hot-toast";
import { updateHomePage, viewHomePage } from "helpers/fakebackend_helper";
import CustomTamilInput from "components/VerticalLayout/CustomTamilInput";
import ImagePopup from "pages/Home-Page/ImagePopup";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


const EnuumTemp = () => {

    const [activeTab, setactiveTab] = useState(1)
    const [activeTabVartical, setoggleTabVertical] = useState(1)

    const [passedSteps, setPassedSteps] = useState([1])
    const [passedStepsVertical, setPassedStepsVertical] = useState([1])
    const [show, setshow] = useState([true, true, true, true])
    const [navId, setNavId] = useState();
    const [slugs, setSlugs] = useState();
    const { state } = useLocation();
    const [btn, setBtn] = useState(false)
    const [showPopup, setShowPopup] = useState(false)
    const handleClose = () => setShowPopup(false);
    const [image_path, setImage_path] = useState("")

       const { slug } = useParams();


    // console.log('state', state);


    const [tab1, setTab1] = useState({
        image_path: "",
        eng_title: "",
        tamil_title: "",
    })

    const [tab2, setTab2] = useState({
        eng_title: "",
        tamil_title: "",
        eng_desc: "",
        tamil_desc: "",
        // image_path:"",
    });

    console.log('tab2', tab2);
    


    const [tab3, setTab3] = useState({
        eng_title: "",
        tamil_title: "",
        missions:
            [
                { id: 1, eng_title: "", tamil_title: "", image_path: ""},
            ],
        eng_mission_title:"",
        tamil_mission_title:"",
        eng_mission : "",
        tamil_mission : "",
        eng_vision_title : "",
        tamil_vision_title : "",
        eng_vision : "",
        tamil_vision :  "",
        mission_images : [{image_path:''}, {image_path:''}, {image_path:''}],
        timeline_list : [
            {   
                id : 1,
                eng_title : "",
                tamil_title : "",
                eng_desc : "",
                tamil_desc : "",
                timeline_order : ""
            }
        ]
    });

    const [tab4, setTab4] = useState({
         gallery_eng_name: "", 
         gallery_tamil_name: "", 
         top1_image: "", 
         top2_image: "", 
         top3_image: '', 
         left_center: '', 
         center: '', 
         right_center: '', 
         bottom1_image: '', 
         bottom2_image: '', 
         bottom3_image: ''
    });

    const handleTab1Change = (e) => {
        const { name, value } = e.target;
        setTab1((p) => ({ ...p, [name]: value }))
    }

    const handleTab2Change = (e) => {
        const { name, value } = e.target;
        setTab2((p) => ({ ...p, [name]: value }))
    }

    const handleTab3Change = (e) => {
        const { name, value } = e.target;
        setTab3((p) => ({ ...p, [name]: value }))
    }

    const handleTab4Change = (e) => {
        const { name, value } = e.target;
        setTab4((p) => ({ ...p, [name]: value }))
    }

    const onAddFormRow = () => {
        const newRow = { id: Math.floor(Math.random() * (30 - 20)) + 20, emp_eng_title: "", emp_tamil_title: "", emp_eng_sub_title: "", emp_tamil_tsub_title: "", image_path: "", redirect_url: '' };
        setTab2({ ...tab2, empowering_lists: [...tab2.empowering_lists, newRow] });
    };

    const onAddFormRow2 = () => {
        const newRow = { id: Math.floor(Math.random() * (30 - 20)) + 20,  
            eng_title : "",
            tamil_title : "",
            eng_desc : "",
            tamil_desc : "",
            timeline_order : ""
        };
        setTab3({ ...tab3, timeline_list: [...tab3.timeline_list, newRow] });
    };

    const onAddFormRow3 = () => {
        const newRow = { id: Math.floor(Math.random() * (30 - 20)) + 20, gallery_eng_name: "", gallery_tamil_name: "", top1_image: "", top2_image: "", top3_image: '', left_center: '', center: '', right_center: '', bottom1_image: '', bottom2_image: '', bottom3_image: '' };
        setTab4({ ...tab4, gallery_lists: [...tab4.gallery_lists, newRow] });
    };


    const onDeleteFormRow = (id) => {
        const updatedRows = tab2.empowering_lists.filter((row) => row.id !== id);
        setTab2({ ...tab2, empowering_lists: updatedRows });
    };

    const onDeleteFormRow2 = (id) => {
        const updatedRows = tab3.timeline_list.filter((row) => row.id !== id);
        setTab3({ ...tab3, timeline_list: updatedRows });
    };

    const onDeleteFormRow3 = (id) => {
        const updatedRows = tab4.gallery_lists.filter((row) => row.id !== id);
        setTab4({ ...tab4, gallery_lists: updatedRows });
    };


    const handleInputChange = (id, name, value) => {
        const updatedRows = tab2.empowering_lists.map(row => {
            if (row.id === id) {
                return { ...row, [name]: value };
            }
            return row;
        });
        setTab2({ ...tab2, empowering_lists: updatedRows });
    };


    const handleInputChange2 = (id, name, value) => {
        const updatedRows = tab3.timeline_list.map(row => {
            if (row.id === id) {
                return { ...row, [name]: value };
            }
            return row;
        });
        setTab3({ ...tab3, timeline_list: updatedRows });
    };

    const handleInputChange3 = (id, name, value) => {
        const updatedRows = tab4.gallery_lists.map(row => {
            if (row.id === id) {
                return { ...row, [name]: value };
            }
            return row;
        });
        setTab4({ ...tab4, gallery_lists: updatedRows });
    };

    const handleTab1Verify = () => {
        if (tab1.tamil_title != "" && tab1.eng_title != "" && tab1.eng_sub_title != "" && tab1.tamil_tsub_title != "" && tab1.redirect_url != '') {
            return true;
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }

    const handleTab2Verify = () => {
        if (tab2.eng_title != "" && tab2.eng_desc != "" && tab2.tamil_desc != ""&& tab2.tamil_title != "") {
            return true;
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }

    const handleTab3Verify = () => {
        if (tab3.eng_mission_title != "" && tab3.tamil_mission_title != "" && tab3.eng_mission != "" && tab3.tamil_mission != "") {
            return true;
        } else if (tab3?.timeline_list.length == 0) {
            toast.error('Add TimeLiine Feilds!')
            return false
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }

    const handleTab4Verify = () => {
        if (tab4.eng_title != "" && tab4.tamil_title != "" && tab4.eng_sub_title != "" && tab4.tamil_tsub_title != "") {
            return true;
        } else if (tab4?.gallery_lists.length == 0) {
            toast.error('Add Gallery Feilds!')
            return false
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }


    function toggleTab(tab) {
        if (activeTab !== tab) {
            var modifiedSteps = [...passedSteps, tab]
            if (tab >= 1 && tab <= 4) {
                setactiveTab(tab)
                setPassedSteps(modifiedSteps)
            }
        }
    }

    function toggleTabVertical(tab) {
        if (activeTabVartical !== tab) {
            var modifiedSteps = [...passedStepsVertical, tab]

            if (tab >= 1 && tab <= 4) {
                setoggleTabVertical(tab)
                setPassedStepsVertical(modifiedSteps)
            }
        }
    }

    const [isLoading, setisLoading] = useState(false)


    const getTemplete = (navigation_id) => {
        let payload = new FormData()

        payload.append('navigation_template_id', navigation_id ?? slug)
        // let payload ={
        //     navigation_id:navigation_id
        // }
        viewHomePage(payload).then((res) => {
            let data = res?.response
            if(data?.banner_json){
            setTab1(data?.banner_json)
        }

            // TAB 2
            if(data?.overview_json){
            setTab2(data?.overview_json)
        }


        if(data?.mission_json){
            // TAB 3
            let commitment_section = data?.mission_json
            let commitment_lists_ = data?.mission_json?.timeline_list ? Object.values(data?.mission_json?.timeline_list) : [];
            let image_lists2_ = data?.mission_json?.mission_images? Object.values(data?.mission_json?.mission_images) : [];
            let commitment_lists = []
            let image_lists2 = []
            commitment_lists_?.map((item, ind) => {
                commitment_lists.push({
                    ...item,
                    id: ind + 1
                })
            })
            image_lists2_?.map((item, ind) => {
                image_lists2.push({
                    ...item,
                    id: ind + 1
                })
            })

            let commitment = {
                ...commitment_section
            }

            commitment.timeline_list = commitment_lists
            commitment.mission_images = image_lists2;
            if(data?.mission_json?.timeline_list || data?.mission_json?.mission_images){
                setTab3(commitment)
            }
        }

        if(data?.gallery_json){
            // TAB 4
            setTab4(data?.gallery_json)
        }
        }).catch((err) => {
            console.log('err', err);

        })
    }

    useEffect(() => {
        if (state?.data) {
            setNavId(state?.data?.id)
            getTemplete(state?.data?.slug)
            setSlugs(state?.data?.slug)
        }

        if(slug){
            getTemplete()
        }
    }, [state])


    const handleSubmitForm = () => {

        var formData = new FormData();
        formData.append('navigation_template_id', slug)

        // tab 1
        formData.append(`banner_json[image_path]`, tab1?.image_path)
        formData.append(`banner_json[tamil_title]`, tab1?.tamil_title)
        formData.append(`banner_json[eng_title]`, tab1?.eng_title)

        // tab 2
        formData.append(`overview_json[eng_title]`, tab2?.eng_title)
        formData.append(`overview_json[tamil_title]`, tab2?.tamil_title)
        formData.append(`overview_json[eng_desc]`, tab2?.eng_desc)
        formData.append(`overview_json[tamil_desc]`, tab2?.tamil_desc)
        // formData.append(`overview_json[image_path]`, tab2?.image_path)

        // tab 3
        formData.append('mission_json[eng_mission_title]', tab3?.eng_mission_title)
        formData.append('mission_json[tamil_mission_title]', tab3?.tamil_mission_title)
        formData.append('mission_json[eng_mission]', tab3?.eng_mission)
        formData.append('mission_json[tamil_mission]', tab3?.tamil_mission)
        formData.append('mission_json[eng_vision_title]', tab3?.eng_vision_title)
        formData.append('mission_json[tamil_vision_title]', tab3?.tamil_vision_title)
        formData.append('mission_json[eng_vision]', tab3?.eng_vision)
        formData.append('mission_json[tamil_vision]', tab3?.tamil_vision)
        
        tab3?.mission_images?.map((data, i) => {
            formData.append(`mission_json[mission_images][${i}][image_path]`, data.image_path)
        }) 

        tab3?.timeline_list?.map((data, i) => {
            formData.append(`mission_json[timeline_list][${i}][eng_title]`, data.eng_title)
            formData.append(`mission_json[timeline_list][${i}][tamil_title]`, data.tamil_title)
            formData.append(`mission_json[timeline_list][${i}][eng_desc]`, data.eng_desc)
            formData.append(`mission_json[timeline_list][${i}][tamil_desc]`, data.tamil_desc)
            formData.append(`mission_json[timeline_list][${i}][timeline_order]`, data.timeline_order)
        }) 
        

        // tab 4
        formData.append(`gallery_json[bottom1_image]`, tab4.bottom1_image)
        formData.append(`gallery_json[bottom2_image]`, tab4.bottom2_image)
        formData.append(`gallery_json[bottom3_image]`, tab4.bottom3_image)
        formData.append(`gallery_json[center]`, tab4.center)
        formData.append(`gallery_json[gallery_eng_name]`, tab4.gallery_eng_name)
        formData.append(`gallery_json[gallery_tamil_name]`, tab4.gallery_tamil_name)
        formData.append(`gallery_json[left_center]`, tab4.left_center)
        formData.append(`gallery_json[right_center]`, tab4.right_center)
        formData.append(`gallery_json[top1_image]`, tab4.top1_image)
        formData.append(`gallery_json[top2_image]`, tab4.top2_image)
        formData.append(`gallery_json[top3_image]`, tab4.top3_image)

        setisLoading(true)
        updateHomePage(formData).then(res => {
            setisLoading(false)
            if (res?.success) {
                toast.success("Added Success")
                getTemplete(state?.data?.slug)
                // router(-1)
            } else {
                toast.error(res?.message ?? 'somthing went wrong!')
            }
        }).catch(err => {
            setisLoading(false)
            toast.error(err.message)
        })
    }


    const getImg = (image_) => {
        setImage_path(image_)
        setShowPopup(true)
    }

    return (
        <>
            <ImagePopup showPopup={showPopup} handleClose={handleClose} image_path={image_path} />
            <div className="page-content">
                <Container fluid={true}>
                <Breadcrumb title="Dashboard" breadcrumbItem={state?.data?.type ?? ''} />
                <Row>
                <Col lg="12">
                <Card>
                    <CardBody>
                        {/* <h4 className="card-title mb-4">Home</h4> */}
                        <div className="wizard clearfix">
                            <div className="steps clearfix">
                                <ul>
                                    <NavItem
                                        className={classnames({ current: activeTab === 1 })}
                                    >
                                        <NavLink
                                            className={classnames({ current: activeTab === 1 })}
                                            onClick={() => {
                                                setactiveTab(1)
                                            }}
                                            disabled={!(passedSteps || []).includes(1)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">1.</span>
                                                Banner Section
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem
                                        className={classnames({ current: activeTab === 2 })}
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === 2 })}
                                            onClick={() => {
                                                setactiveTab(2)
                                            }}
                                            disabled={!(passedSteps || []).includes(2)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">2.</span>
                                                Overview Section
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem
                                        className={classnames({ current: activeTab === 3 })}
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === 3 })}
                                            onClick={() => {
                                                setactiveTab(3)
                                            }}
                                            disabled={!(passedSteps || []).includes(3)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">3.</span> Mission Section
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem
                                        className={classnames({ current: activeTab === 4 })}
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === 4 })}
                                            onClick={() => {
                                                setactiveTab(4)
                                            }}
                                            disabled={!(passedSteps || []).includes(4)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">4.</span> Gallery Section
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                </ul>
                            </div>

                            <div className="content clearfix">
                                <TabContent activeTab={activeTab} className="body">
                                    <TabPane tabId={1}>
                                        {/* <div className="d-flex justify-content-end w-100">
                                            <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                setshow((p) => {
                                                    const h = [...p];
                                                    h[0] = !h[0];
                                                    return h;
                                                })
                                            }}>{show[0] ? "Show" : 'Hidden'}</button>
                                        </div> */}
                                        <Form>
                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">
                                                            English Title <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            name="eng_title"
                                                            onChange={handleTab1Change}
                                                            value={tab1?.eng_title}
                                                            className="form-control"
                                                            id="basicpill-firstname-input1"
                                                            placeholder="Enter English Title"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-lastname-input2">
                                                            Tamil Title <span className="text-danger">*</span>
                                                        </Label>
                                                        <CustomTamilInput
                                                            value={tab1.tamil_title}
                                                            setValue={(e) => setTab1((p) => ({ ...p, tamil_title: e }))}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="imag">
                                                            Image <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="file"
                                                            onChange={(e) => setTab1((p) => ({ ...p, image_path: e.target.files[0] }))}
                                                            className="form-control"
                                                            id="imag"
                                                            placeholder="Enter Your Email ID"
                                                        />
                                                    </div>
                                                    {tab1?.image_path && <button type="button" className="btn btn-primary" onClick={()=>{
                                                        getImg(tab1?.image_path)
                                                    }}>Preview</button>}
                                                </Col>
                                            </Row>
                                        </Form>
                                    </TabPane>

                                    <TabPane tabId={2}>
                                        <div>
                                            {/* <div className="d-flex justify-content-end w-100">
                                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                    setshow((p) => {
                                                        const h = [...p];
                                                        h[1] = !h[1];
                                                        return h;
                                                    })
                                                }}>{show[1] ? "Show" : 'Hidden'}</button>
                                            </div> */}
                                            <Form>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-eng-input5">
                                                                English Title <span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                type="text"
                                                                name="eng_title"
                                                                onChange={handleTab2Change}
                                                                className="form-control"
                                                                id="basicpill-eng-input5"
                                                                placeholder="Enter English Title."
                                                                value={tab2?.eng_title}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-hgsd-input6">
                                                                Tamil Title <span className="text-danger">*</span>
                                                            </Label>
                                                            <CustomTamilInput
                                                                value={tab2.tamil_title}
                                                                name={'tamil_title'}
                                                                setValue={(e) => setTab2((p) => ({ ...p, tamil_title: e }))}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-suib-input7">
                                                                English Desc <span className="text-danger">*</span>
                                                            </Label>
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={tab2.eng_desc}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setTab2((p) => ({ ...p, eng_desc: data }))
                                                                }}
                                                                config={{
                                                                    toolbar: {
                                                                        items:  [
                                                                            'undo',
                                                                            'redo',
                                                                            '|',
                                                                            'bold',
                                                                            'italic',
                                                                            '|',
                                                                            'numberedList', // Added numbered list button
                                                                            'bulletedList',  // Added bulleted list button
                                                                          ],
                                                                        maxWordCount: 10,
                                                                    },
                                                                    // plugins: [
                                                                    //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                                    // ],
                                                                    // licenseKey: '<YOUR_LICENSE_KEY>',
                                                                    mention: {
                                                                        // Mention configuration
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-ygksd-input8">
                                                                Tamil Desc <span className="text-danger">*</span>
                                                            </Label>
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={tab2.tamil_desc}
                                                                onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setTab2((p) => ({ ...p, tamil_desc: data }))
                                                                }}
                                                                config={{
                                                                    toolbar: {
                                                                        items:  [
                                                                            'undo',
                                                                            'redo',
                                                                            '|',
                                                                            'bold',
                                                                            'italic',
                                                                            '|',
                                                                            'numberedList', // Added numbered list button
                                                                            'bulletedList',  // Added bulleted list button
                                                                          ],
                                                                        maxWordCount: 10,
                                                                    },
                                                                    // plugins: [
                                                                    //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                                    // ],
                                                                    // licenseKey: '<YOUR_LICENSE_KEY>',
                                                                    mention: {
                                                                        // Mention configuration
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    </Col> 

                                                    {/* <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="imag">
                                                            Image <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="file"
                                                            onChange={(e) => setTab2((p) => ({ ...p, image_path: e.target.files[0] }))}
                                                            className="form-control"
                                                            id="imag"
                                                            placeholder="Enter Your Email ID"
                                                        />
                                                    </div>
                                                    {tab2?.image_path && <button className="btn btn-primary" onClick={()=>{
                                                        getImg(tab2?.image_path)
                                                    }}>Preview</button>}
                                                </Col> */}

                                                </Row>
                                            </Form>
                                        </div>
                                    </TabPane>

                                    <TabPane tabId={3}>
                                        <div>
                                            {/* <div className="d-flex justify-content-end w-100">
                                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                    setshow((p) => {
                                                        const h = [...p];
                                                        h[2] = !h[2];
                                                        return h;
                                                    })
                                                }}>{show[2] ? "Show" : 'Hidden'}</button>

                                            </div> */}

                                            <Form>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-eng-input5">
                                                                English Mission Title <span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                type="text"
                                                                name="eng_mission_title"
                                                                onChange={handleTab3Change}
                                                                className="form-control"
                                                                id="basicpill-eng-input5"
                                                                placeholder="Enter English Title."
                                                                value={tab3?.eng_mission_title}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-hgsd-input6">
                                                                Tamil Mission Title <span className="text-danger">*</span>
                                                            </Label>
                                                            <CustomTamilInput
                                                                value={tab3.tamil_mission_title}
                                                                name={'tamil_mission_title'}
                                                                setValue={(e) => setTab3((p) => ({ ...p, tamil_mission_title: e }))}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-eng-input5">
                                                                English Mission <span className="text-danger">*</span>
                                                            </Label>
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={tab3.eng_mission}
                                                                    onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setTab3((p) => ({ ...p, eng_mission: data }))
                                                                }}
                                                                config={{
                                                                    toolbar: {
                                                                        items:  [
                                                                            'undo',
                                                                            'redo',
                                                                            '|',
                                                                            'bold',
                                                                            'italic',
                                                                            '|',
                                                                            'numberedList',
                                                                            'bulletedList', 
                                                                            ],
                                                                        maxWordCount: 10,
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-hgsd-input6">
                                                                Tamil Mission <span className="text-danger">*</span>
                                                            </Label>
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={tab3.tamil_mission}
                                                                    onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setTab3((p) => ({ ...p, tamil_mission: data }))
                                                                }}
                                                                config={{
                                                                    toolbar: {
                                                                        items:  [
                                                                            'undo',
                                                                            'redo',
                                                                            '|',
                                                                            'bold',
                                                                            'italic',
                                                                            '|',
                                                                            'numberedList',
                                                                            'bulletedList', 
                                                                            ],
                                                                        maxWordCount: 10,
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-eng-input5">
                                                                English Vision Title <span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                type="text"
                                                                name="eng_vision_title"
                                                                onChange={handleTab3Change}
                                                                className="form-control"
                                                                id="basicpill-eng-input5"
                                                                placeholder="Enter English Title."
                                                                value={tab3?.eng_vision_title}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-hgsd-input6">
                                                                Tamil Vision Title <span className="text-danger">*</span>
                                                            </Label>
                                                            <CustomTamilInput
                                                                value={tab3.tamil_vision_title}
                                                                name={'tamil_vision_title'}
                                                                setValue={(e) => setTab3((p) => ({ ...p, tamil_vision_title: e }))}
                                                            />
                                                        </div>
                                                    </Col>


                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-eng-input5">
                                                                English Vision <span className="text-danger">*</span>
                                                            </Label>
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={tab3.eng_vision}
                                                                    onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setTab3((p) => ({ ...p, eng_vision: data }))
                                                                }}
                                                                config={{
                                                                    toolbar: {
                                                                        items:  [
                                                                            'undo',
                                                                            'redo',
                                                                            '|',
                                                                            'bold',
                                                                            'italic',
                                                                            '|',
                                                                            'numberedList',
                                                                            'bulletedList', 
                                                                            ],
                                                                        maxWordCount: 10,
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-hgsd-input6">
                                                                Tamil Vision <span className="text-danger">*</span>
                                                            </Label>
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={tab3.tamil_vision}
                                                                    onChange={(event, editor) => {
                                                                    const data = editor.getData();
                                                                    setTab3((p) => ({ ...p, tamil_vision: data }))
                                                                }}
                                                                config={{
                                                                    toolbar: {
                                                                        items:  [
                                                                            'undo',
                                                                            'redo',
                                                                            '|',
                                                                            'bold',
                                                                            'italic',
                                                                            '|',
                                                                            'numberedList',
                                                                            'bulletedList', 
                                                                            ],
                                                                        maxWordCount: 10,
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>

                                            <h6 className="mb-3 mt-3 card-title">Mission Images<span className="text-danger">*</span></h6>
                                            <Form className="repeater" encType="multipart/form-data" >
                                            <Row  className="align-items-center">
                                            {(tab3.mission_images || [])?.map((formRow, key) => (
                                                <Col key={key} lg="6" className="mb-2">
                                                    <div className="mb-3">
                                                        <Label for="imag">
                                                        Image {key +1}
                                                        <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                        type="file"
                                                        onChange={e =>
                                                        setTab3((p) => ({...p, mission_images :tab3.mission_images.map((op,i) => {
                                                            if(i == key){
                                                               return {...op, image_path : e.target.files[0]}
                                                            }
                                                            return op 
                                                        })}))
                                                        }
                                                        className="form-control"
                                                        id="imag"
                                                        />
                                                    </div>

                                                    {formRow?.image_path && (
                                                        <button
                                                        className="btn btn-primary"
                                                        type="button"
                                                        onClick={() => {
                                                            getImg(formRow?.image_path)
                                                        }}
                                                        >
                                                        Preview
                                                        </button>
                                                    )}
                                                    {/* {
                                                        key != 0 && (
                                                            <input 
                                                               type="button"
                                                               className="btn btn-danger ms-2"
                                                               value="Delete"
                                                               onClick={() => setTab3((p) => ({...p, mission_images:p.mission_images.filter((r,o) => o != key )}))}
                                                               />
                                                        )
                                                    } */}
                                                </Col>
                                            ))}
                                            {/* <Col sm='12'>
                                             <input 
                                                type="button"
                                                className="btn btn-success mt-2"
                                                value="Add Images"
                                                onClick={() => setTab3((p) => ({...p, mission_images:[...p.mission_images,{image_path:''}]}))}
                                              />
                                            </Col> */}
                                            </Row>
                                            </Form>

                                            <h6 className="mb-3 mt-3 card-title">Time Line<span className="text-danger">*</span></h6>
                                            <Form className="repeater" encType="multipart/form-data" >
                                                <div>
                                                    {(tab3?.timeline_list || [])?.map((formRow, key) => (
                                                        <Row key={key} className="align-items-center">
                                                            <Col lg={6} className="mb-3">
                                                                <label htmlFor="eng_title">English Title<span className="text-danger">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    id="eng_title"
                                                                    name={`eng_title_${formRow.id}`}
                                                                    value={formRow.eng_title}
                                                                    onChange={(e) => handleInputChange2(formRow.id, 'eng_title', e.target.value)}
                                                                    className="form-control"
                                                                    placeholder="Enter English Title"
                                                                />
                                                            </Col>

                                                            <Col lg={6} className="mb-3">
                                                                <label htmlFor="tamil_title">Tamil Title<span className="text-danger">*</span></label>
                                                                <CustomTamilInput
                                                                    value={formRow.tamil_title}
                                                                    name={`tamil_title${formRow.id}`}
                                                                    setValue={(e) => handleInputChange2(formRow.id, 'tamil_title', e)}
                                                                />
                                                            </Col>

                                                            <Col lg="6">
                                                                <div className="mb-3">
                                                                    <Label useEffectfor="basicpill-suib-input7">
                                                                        English Desc <span className="text-danger">*</span>
                                                                    </Label>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={formRow.eng_desc}
                                                                            onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            handleInputChange2(formRow.id, 'eng_desc', data)
                                                                        }}
                                                                        config={{
                                                                            toolbar: {
                                                                                items:  [
                                                                                    'undo',
                                                                                    'redo',
                                                                                    '|',
                                                                                    'bold',
                                                                                    'italic',
                                                                                    '|',
                                                                                    'numberedList',
                                                                                    'bulletedList', 
                                                                                    ],
                                                                                maxWordCount: 10,
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Col>
                    
                                                            <Col lg="6">
                                                                <div className="mb-3">
                                                                    <Label for="basicpill-ygksd-input8">
                                                                        Tamil Desc <span className="text-danger">*</span>
                                                                    </Label>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={formRow.tamil_desc}
                                                                        onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            handleInputChange2(formRow.id, 'tamil_desc', data)
                                                                        }}
                                                                        config={{
                                                                            toolbar: {
                                                                                items:  [
                                                                                    'undo',
                                                                                    'redo',
                                                                                    '|',
                                                                                    'bold',
                                                                                    'italic',
                                                                                    '|',
                                                                                    'numberedList',
                                                                                    'bulletedList',
                                                                                    ],
                                                                                maxWordCount: 10,
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Col>

                                                            <Col lg={6} className="mb-3">
                                                                <label>Time Line Order<span className="text-danger">*</span></label>
                                                                <input
                                                                    type="number"
                                                                    id="timeline_order"
                                                                    name={`eng_title_${formRow.id}`}
                                                                    value={formRow.timeline_order}
                                                                    onChange={(e) => handleInputChange2(formRow.id, 'timeline_order', e.target.value)}
                                                                    className="form-control"
                                                                    placeholder="Enter Timeline Order"
                                                                />
                                                            </Col>

                                                            {key > 0 && <Col lg={2} className="mb-2 align-self-center">
                                                                <div className="d-grid">
                                                                    <input
                                                                        type="button"
                                                                        className="btn btn-danger"
                                                                        value="Delete"
                                                                        onClick={() => onDeleteFormRow2(formRow.id)}
                                                                    />
                                                                </div>
                                                            </Col>}
                                                        </Row>
                                                    ))}
                                                </div>
                                                <input
                                                    type="button"
                                                    className="btn btn-success mt-3 mt-lg-0"
                                                    value="Add Time Line"
                                                    onClick={() => onAddFormRow2()}
                                                />
                                            </Form>
                                        </div>
                                    </TabPane>

                                    <TabPane tabId={4}>
                                        <div>
                                            {/* <div className="d-flex justify-content-end w-100">
                                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                    setshow((p) => {
                                                        const h = [...p];
                                                        h[3] = !h[3];
                                                        return h;
                                                    })
                                                }}>{show[3] ? "Show" : 'Hidden'}</button>

                                            </div> */}
                                            <Form>
                                            <Row  className="align-items-center">
                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="gallery_eng_name">English Title<span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    id="gallery_eng_name"
                                                    name={`gallery_eng_name`}
                                                    value={tab4.gallery_eng_name}
                                                    onChange={handleTab4Change}
                                                    className="form-control"
                                                    placeholder="Enter English Title"
                                                />
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="gallery_tamil_name">Tamil Title<span className="text-danger">*</span></label>
                                                <CustomTamilInput
                                                    value={tab4.gallery_tamil_name}
                                                    name={`gallery_tamil_name`}
                                                    setValue={(e) => setTab4((p) => ({ ...p, gallery_tamil_name: e }))}
                                                />
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="top1_image">Top 1 Image<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    id="top1_image"
                                                    name={`top1_image`}
                                                    // value={formRow.top1_image}
                                                    onChange={(e) => setTab4((p) => ({ ...p, top1_image: e.target.files[0] }))}
                                                    className="form-control"
                                                />
                                                    {tab4?.top1_image && <div role="button" className="btn btn-primary mt-2" onClick={()=>{
                                                        getImg(tab4?.top1_image)
                                                    }}>Preview</div>}
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="top2_image">Top 2 Image<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    id="top2_image"
                                                    name={`top2_image`}
                                                    // value={formRow.top2_image}
                                                    onChange={(e) => setTab4((p) => ({ ...p, top2_image: e.target.files[0] }))}
                                                    className="form-control"
                                                    placeholder=""
                                                />
                                                    {tab4?.top2_image && <div role="button" className="btn btn-primary mt-2" onClick={()=>{
                                                        getImg(tab4?.top2_image)
                                                    }}>Preview</div>}
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="top3_image">Top 3 Image<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    id="top3_image"
                                                    name={`top3_image`}
                                                    // value={formRow.top3_image}
                                                    onChange={(e) => setTab4((p) => ({ ...p, top3_image: e.target.files[0] }))}
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                    {tab4?.top3_image && <div role="button" className="btn btn-primary mt-2" onClick={()=>{
                                                        getImg(tab4?.top3_image)
                                                    }}>Preview</div>}
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="left_center">Left Center<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="left_center"
                                                    name={`left_center`}
                                                    // value={formRow.left_center}
                                                    onChange={(e) => setTab4((p) => ({ ...p, left_center: e.target.files[0] }))}
                                                />
                                                {tab4?.left_center && <div role="button" className="btn btn-primary mt-2" onClick={()=>{
                                                    getImg(tab4?.left_center)
                                                }}>Preview</div>}
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="center">Center<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="center"
                                                    name={`center`}
                                                    // value={formRow.center}
                                                    onChange={(e) => setTab4((p) => ({ ...p, center: e.target.files[0] }))}
                                                />
                                                {tab4?.center && <div role="button" className="btn btn-primary mt-2" onClick={()=>{
                                                    getImg(tab4?.center)
                                                }}>Preview</div>}
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="right_center">Right center<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="right_center"
                                                    name={`right_center`}
                                                    // value={formRow.right_center}
                                                    onChange={(e) => setTab4((p) => ({ ...p, right_center: e.target.files[0] }))}
                                                />
                                                {tab4?.right_center && <div role="button" className="btn btn-primary mt-2" onClick={()=>{
                                                    getImg(tab4?.right_center)
                                                }}>Preview</div>}
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="bottom1_image">Bottom 1 Image<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="bottom1_image"
                                                    name={`bottom1_image`}
                                                    // value={formRow.bottom1_image}
                                                    onChange={(e) => setTab4((p) => ({ ...p, bottom1_image: e.target.files[0] }))}
                                                />
                                                {tab4?.bottom1_image && <div role="button" className="btn btn-primary mt-2" onClick={()=>{
                                                    getImg(tab4?.bottom1_image)
                                                }}>Preview</div>}
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="bottom2_image">Bottom 2 Image<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="bottom2_image"
                                                    name={`bottom2_image`}
                                                    // value={formRow.bottom2_image}
                                                    onChange={(e) => setTab4((p) => ({ ...p, bottom2_image: e.target.files[0] }))}
                                                />
                                                    {tab4?.bottom2_image && <div role="button" className="btn btn-primary mt-2" onClick={()=>{ 
                                                        getImg(tab4?.bottom2_image)
                                                    }}>Preview</div>}
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="bottom3_image">Bottom 3 Image<span className="text-danger">*</span></label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="bottom3_image"
                                                    name={`bottom3_image`}
                                                    // value={formRow.bottom3_image}
                                                    onChange={(e) => setTab4((p) => ({ ...p, bottom3_image: e.target.files[0] }))}
                                                />
                                                {tab4?.bottom3_image && <div role="button" className="btn btn-primary mt-2" onClick={()=>{
                                                    getImg(tab4?.bottom3_image)
                                                }}>Preview</div>}
                                            </Col>
                                            </Row>
                                            </Form>
                                        </div>
                                    </TabPane>
                                </TabContent>
                            </div>

                            <div className="actions clearfix">
                                <ul>
                                    <li
                                        className={
                                            activeTab === 1 ? "previous disabled" : "previous"
                                        }
                                    >
                                        <button
                                            onClick={() => {
                                                toggleTab(activeTab - 1)
                                            }}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    <li
                                        className={activeTab === 4 ? "next" : "next"}
                                    >

                                        {
                                            activeTab === 4 ?

                                                <button type="button" onClick={() => handleSubmitForm()} className="btn btn-primary">
                                                    {
                                                        isLoading ?
                                                            <>
                                                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                                Loading
                                                            </>
                                                            :
                                                            "Submit"
                                                    }
                                                </button>
                                                :

                                                <button
                                                    onClick={() => {
                                                        if (activeTab == 1) {

                                                            if (!show[0] || handleTab1Verify()) {
                                                                toggleTab(activeTab + 1)
                                                            }
                                                        } else if (activeTab == 2) {
                                                            if (!show[1] || handleTab2Verify()) {
                                                                toggleTab(activeTab + 1)
                                                            }
                                                        } else if (activeTab == 3) {
                                                            if (!show[2] || handleTab3Verify()) {
                                                                toggleTab(activeTab + 1)
                                                            }
                                                        } else if (activeTab == 4) {
                                                            if (!show[0] || handleTab4Verify()) {
                                                                toggleTab(activeTab + 1)
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Next
                                                </button>
                                        }
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </CardBody>
                </Card>
                </Col>
                </Row>
                </Container>
            </div>
        </>
    )
}


export default withRouter(EnuumTemp);